import React from 'react'
import styles from '../index.module.scss'
import InputCustom from '../../atoms/input/InputCustom'
import SelectCustom from '../../atoms/select/SelectCustom'
import { Grid } from '@mui/material'

const DecorRentals = () => {
	return (
		<>
			<div>
				<h3 className={styles.Title}>Decor/Rentals Survey</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="companyContactName"
								className={styles.label}
							>
								Company contact name
							</label>
							<InputCustom
								id="companyContactName"
								name="companyContactName"
								placeholder="Enter Company contact name"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="companyContactNumber"
								className={styles.label}
							>
								Company contact number
							</label>
							<InputCustom
								id="companyContactNumber"
								name="companyContactNumber"
								placeholder="Enter Company Contact Number"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="typeOfDecor"
								className={styles.label}
							>
								Type of décor provided
							</label>
							<InputCustom
								id="typeOfDecor"
								name="typeOfDecor"
								placeholder="e.g., arches, draping, centerpieces, lighting, etc."
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="setupTeamSize"
								className={styles.label}
							>
								Setup team size
							</label>
							<InputCustom
								id="setupTeamSize"
								name="setupTeamSize"
								placeholder="Enter setup team size"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Timeline Details</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="deliveryDateTime"
								className={styles.label}
							>
								Delivery date/time
							</label>
							<InputCustom
								id="deliveryDateTime"
								name="deliveryDateTime"
								placeholder="Enter details"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="setupDateTime"
								className={styles.label}
							>
								Setup start & end time
							</label>
							<InputCustom
								id="setupDateTime"
								name="setupDateTime"
								placeholder="Enter details"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="teardownDateTime"
								className={styles.label}
							>
								Teardown/cleanup start & end time
							</label>
							<InputCustom
								id="teardownDateTime"
								name="teardownDateTime"
								placeholder="Enter details"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="accessRequirements"
								className={styles.label}
							>
								Access requirements
							</label>
							<InputCustom
								id="accessRequirements"
								name="accessRequirements"
								placeholder="e.g., loading dock"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Dependencies</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="venueSetupWindow"
								className={styles.label}
							>
								Venue setup window
							</label>
							<InputCustom
								id="venueSetupWindow"
								name="venueSetupWindow"
								placeholder="Enter venue setup window"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="coordinationWithVendorCategories"
								className={styles.label}
							>
								Coordination with vendor categories?
							</label>
							<SelectCustom
								id="coordinationWithVendorCategories"
								name="coordinationWithVendorCategories"
								label="Select"
								options={[
									{ value: 'option1', label: 'Option 1' },
									{ value: 'option2', label: 'Option 2' },
									{ value: 'option3', label: 'Option 3' },
								]}
							></SelectCustom>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Notes</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12 }}>
						<div className={styles.formField}>
							<label htmlFor="floorPlan" className={styles.label}>
								Upload floor plan or layout (optional)
							</label>
							<InputCustom
								id="floorPlan"
								name="floorPlan"
								placeholder="Enter notes"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Other Questions</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="rainContingency"
								className={styles.label}
							>
								Rain contingency or setup change needed?
							</label>
							<InputCustom
								id="rainContingency"
								name="rainContingency"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="setupDuration"
								className={styles.label}
							>
								Setup / teardown duration
							</label>
							<InputCustom
								id="setupDuration"
								name="setupDuration"
								placeholder="Enter details"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="specialEquipment"
								className={styles.label}
							>
								Special equipment or space needs?
							</label>
							<InputCustom
								id="specialEquipment"
								name="specialEquipment"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="contactForDayOfEmergencies"
								className={styles.label}
							>
								Contact for day-of emergencies
							</label>
							<InputCustom
								id="contactForDayOfEmergencies"
								name="contactForDayOfEmergencies"
								placeholder="Enter contact for day-of emergencies"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}

export default DecorRentals
